import React from 'react'
import { Container, FloatingLabel, Form,  Button,ListGroup  } from 'react-bootstrap'
import "bootstrap/dist/css/bootstrap.min.css";
import {Jumbotron} from "react-bootstrap"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import about from '../../assets/images/gn_bank_cover.jpeg'
import {faCoffee} from '@fortawesome/free-solid-svg-icons/faCoffee'
import {faPhone} from '@fortawesome/free-solid-svg-icons/faPhone'
import {faMailBulk} from '@fortawesome/free-solid-svg-icons/faMailBulk'
import {faLocation} from '@fortawesome/free-solid-svg-icons/faLocation'
import Mynav from '../../components/Header/Header'
import SimpleHero from '../../components/SimpleHero/SimpleHero'

const Contact = () => {
  return (
    <Container fluid={true}>
  
     
     


  <SimpleHero
    title="We’re here to help"
    subtitle="Call +1 (773) 624‑2000, email support@gnbank.net, or visit 4619 S. King Drive, Chicago, IL."
    primaryLabel="Find a location"
    primaryHref="/location"
    variant="sofi"
    imageSrc={about}
    imageAlt="Contact GN Bank"
    imageOn="right"
    tiltImage
    badges={["Phone","Email","Visit"]}
  />

        <main className="mb-4">
            <div className="container px-4 px-lg-5">
                <div className="row gx-4 gx-lg-5 justify-content-center">
                    <div className="col-md-6 col-lg-6 col-xl-7 mt-4">
                        <p>Want to get in touch? Fill out the form below to send me a message and I will get back to you as soon as possible!</p>
                        <div className="my-5">
                          
                            <form id="contactForm" data-sb-form-api-token="API_TOKEN">
                                
                            <>
      <FloatingLabel
        controlId="floatingInput"
        label="Email address"
        className="mb-3"
      >
        <Form.Control type="email" placeholder="name@example.com" />
      </FloatingLabel>

      <FloatingLabel controlId="floatingPassword" name="name" label="Enter Name " className="mb-3">
        <Form.Control type="text" placeholder="Name" />
      </FloatingLabel>


      <FloatingLabel
        controlId="floatingInput"
        label="Phone Number"
        className="mb-3"
      >
        <Form.Control type="tel" placeholder="Phone Number" />
      </FloatingLabel>

     
      <FloatingLabel controlId="floatingTextarea2" label="Comments" className='mb-3 float-right text-right'>
        <Form.Control
          as="textarea"
          placeholder="Leave a comment here"
          style={{ height: '100px' }}
        />
      </FloatingLabel>

      
    </>
                                <div className="d-none" id="submitErrorMessage"><div className="text-center text-danger mb-3">Error sending message!</div></div>
                               
                                <button className="btn gn-button text-uppercase disabled" id="submitButton" type="submit">Send</button>
                            </form>
                        </div>
                    </div>

                    <div className='col-md-6 col-lg-6 col-xl-5 mt-4'>
                      <div className='py-5'></div>
                      <div className='py-3'></div>
                    <ListGroup as="ul" variant="flush">
      <ListGroup.Item as="li" >
        <h5 className='gn-title h5'><FontAwesomeIcon icon={faPhone} /> +1773-624-2000</h5>
      </ListGroup.Item>
      <ListGroup.Item as="li"><h5 className='h5 gn-title'><FontAwesomeIcon icon={faMailBulk}  className=' mr-5 ' /> support@gnbank.net</h5></ListGroup.Item>
      <ListGroup.Item as="li">
      <p className='mr-4 pr-3 h5 gn-title'><FontAwesomeIcon icon={faLocation}  className=' mr-5'/> 4619 S. King Drive , Chicago , IL 60653 </p>
      </ListGroup.Item>
      <ListGroup.Item as="li"></ListGroup.Item>
    </ListGroup>
                    </div>
                </div>
            </div>
        </main>
    </Container>
  )
}

export default Contact
